import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const KeyboardShortcut = ({ children, qaId }) => {
  let shortcut = children;
  let isDirectionKey = true;

  if (children === 'up') {
    shortcut = '↑';
  } else if (children === 'right') {
    shortcut = '→';
  } else if (children === 'down') {
    shortcut = '↓';
  } else if (children === 'left') {
    shortcut = '←';
  } else {
    isDirectionKey = false;
  }

  const kbdShortcutClasses = classNames('uni-keyboard-shortcut', {
    'uni-keyboard-shortcut--is-one-character': children.length === 1 || isDirectionKey,
    'uni-keyboard-shortcut--is-direction-key': isDirectionKey,
  });

  return (
    <kbd className={kbdShortcutClasses} data-qa-id={qaId}>
      {shortcut}
    </kbd>
  );
};

KeyboardShortcut.propTypes = {
  children: PropTypes.node,
  qaId: PropTypes.string,
};

export default KeyboardShortcut;



// WEBPACK FOOTER //
// ./src/keyboard-shortcut/index.jsx